export default __webpack_public_path__ + "static/media/crc-block-cc-color.0e9ac57d.svg";